<script setup lang="ts">
import { computed } from 'vue'
import Section from '../Section.vue'
import { TextSectionContent } from './types'
import { getColorById } from '../utils'
import { SectionSettings } from '../types'

interface Props {
  content: TextSectionContent
  settings?: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  settings: (_s) =>
    ({
      alignment: 'center',
      cta: 'Learn more',
      cta_url: '#',
      show_cta: true,
      title: 'Text section',
      design_settings: {
        colors: [],
        fonts: [],
      },
    }) as SectionSettings,
  content: () =>
    ({
      text: 'This is the main text of the section',
    }) as TextSectionContent,
})

const buttonColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'button_color'),
)
const buttonTextColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'button_text_color'),
)

const styles = computed(() => ({
  backgroundColor: buttonColor.value,
  color: buttonTextColor.value,
}))
</script>

<template>
  <Section :settings="settings">
    <div class="text-section">
      <p class="main-text mb-4">{{ content.text }}</p>
      <a
        v-if="settings.show_cta && settings.cta && settings.cta_url"
        class="btn btn-secondary cta fs-sm"
        target="_blank"
        :href="settings.cta_url || '#'"
        :style="styles"
        >{{ settings.cta }}</a
      >
    </div>
  </Section>
</template>

<style scoped lang="sass">
.text-section
  margin-top: 2rem
.main-text
  line-height: 2rem
.btn.cta
  padding: 0.3rem 2rem
  max-width: 300px
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
</style>
